const typeUrlPrefix = 'type.googleapis.com';

type GetTypeNameFromPackageAndEventNames = (packageName: string, eventName: string) => string;
export const getTypeNameFromPackageAndEventNames: GetTypeNameFromPackageAndEventNames = (packageName, eventName) =>
  `${packageName}.${eventName}`;

type GetTypeUrlFromTypeName = (typeName: string) => string;
export const getTypeUrlFromTypeName: GetTypeUrlFromTypeName = (typeName) => `${typeUrlPrefix}/${typeName}`;
